import * as types from 'actions/actionTypes';
import initialState from '../initialState';

/**
 * reducer per gestire le interrogazioni a crashboxx - download lista pdf
 * @param {*} state
 * @param {*} action
 */
export default function crashboxxDownloadListPdfReducer(state = initialState.crashboxxFiles.listPdf, action){

    switch(action.type)
    {
        case types.DOWNLOAD_LISTPDF_REQUEST:
            return {...state, error: null, isLoading: true};
        case types.DOWNLOAD_LISTPDF_SUCCESS:
            return {...state, error: null, isLoading: false};
        case types.DOWNLOAD_LISTPDF_ERROR:
            return {...state, error: action.error, isLoading: false};
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/crashboxx/crashboxxDownloadListPdfReducer.js